/** Renderer capability probe. Pure over injected globals so it can be unit-tested. */
export interface RenderCapabilities {
  webgpu: boolean;
  webgl2: boolean;
}

export interface CapabilityProbeEnv {
  hasWebGPU: () => boolean;
  hasWebGL2: () => boolean;
}

export function detectCapabilities(env: CapabilityProbeEnv): RenderCapabilities {
  return { webgpu: safe(env.hasWebGPU), webgl2: safe(env.hasWebGL2) };
}

function safe(fn: () => boolean): boolean {
  try {
    return fn();
  } catch {
    return false;
  }
}

/** Which backend `WebGPURenderer` will pick, per BUILD_PLAN section 2. */
export function describeBackend(c: RenderCapabilities): string {
  if (c.webgpu) return 'WebGPU';
  if (c.webgl2) return 'WebGL 2 (fallback)';
  return 'unsupported';
}

export const browserProbeEnv: CapabilityProbeEnv = {
  hasWebGPU: () => 'gpu' in navigator && navigator.gpu !== undefined,
  hasWebGL2: () => document.createElement('canvas').getContext('webgl2') !== null,
};
